module.exports = __webpack_public_path__ + "img/index-footer.a6be0f6c.png";